import { createFileRoute, redirect } from "@tanstack/react-router";

/** 系统元数据模板页已下线：预置经行业包管理维护 */
export const Route = createFileRoute("/_app/settings/metadata-templates")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/industry-packs" });
  },
});
